import app from "@/main";
import {UyapRequest} from "@/plugins/uyap-plugin/uyap/UyapRequest";

export interface KullaniciBilgileriTalep{}

export interface KullaniciBilgileriCevap {
    tcKimlikNo: string
    adi: string
    soyadi: string
    bilirkisiMi: boolean
    arabulucuMu: boolean
    uzlastirmaciMi: boolean
    eDevletLevel: number
    isKamuAvukati: boolean
    isUzmanArabulucu: boolean
    portalSozlesmeOnayDVO: PortalSozlesmeOnayDvo
    vekilTipi: string
}

export interface PortalSozlesmeOnayDvo {
    onay: boolean
}

export default class KullaniciBilgileri extends UyapRequest<KullaniciBilgileriTalep, KullaniciBilgileriCevap> {
    delayTime = 0;

    /**
     * Oturumun kime ait olduğunu ÖĞREnen istek budur; kimlik kapısından muaf.
     * Muaf olmasaydı denetim kendi verisini bekleyip kilitlenirdi.
     * Cevabı çağıran tarafta denetleniyor (connectToUyap / checkUyapSession).
     */
    protected kimlikDenetimindenMuaf(): boolean {
        return true;
    }

    getMethod(): "POST" | "GET" {
        return "POST";
    }

    getSpinnerMessage(){
        return "Kullanıcı bilgileri sorgulanıyor...";
    }

    cache() {
        const kimlikNo = app.$store?.getters?.userData?.kimlik_no ?? "anonymous";
        return {
            active: false,
            ttl: (60 * 24),
            key: `KullaniciBilgileri_${kimlikNo}`
        };
    }

    getMockResponse(): KullaniciBilgileriCevap {
        return {
            tcKimlikNo: "11111111111",
            adi: "Demo",
            soyadi: "Kullanici",
            bilirkisiMi: false,
            arabulucuMu: false,
            uzlastirmaciMi: false,
            eDevletLevel: 3,
            isKamuAvukati: false,
            isUzmanArabulucu: false,
            portalSozlesmeOnayDVO: {
                onay: true
            },
            vekilTipi: "AVUKAT"
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "kullanici_bilgileri.uyap";
    }

    async parse(data: any): Promise<KullaniciBilgileriCevap> {
        if (Array.isArray(data) && data.length > 0) {
            return data[0] as KullaniciBilgileriCevap;
        }
        if (data && typeof data === "object") {
            return data as KullaniciBilgileriCevap;
        }
        throw new Error("Kullanıcı bilgileri alınamadı");
    }
}
